import {BlindPosition, FabricTone, FrameColour, IndoorOutdoor, TimeOfDay} from './types';

const ALL_FRAME_COLOURS = [
    FrameColour.PureWhite,
    FrameColour.SurfMist,
    FrameColour.ClassicCream,
    FrameColour.Paperbark,
    FrameColour.WoodlandGrey,
    FrameColour.Monument,
    FrameColour.Bronze,
    FrameColour.Black,
];

const ALL_BLIND_POSITIONS = [
    BlindPosition.Open,
    BlindPosition.Closed,
];

const ALL_FABRIC_TONES = [
    FabricTone.Light,
    FabricTone.Dark,
];

const ALL_INDOOR_OUTDOORS = [
    IndoorOutdoor.Outdoor,
    IndoorOutdoor.Indoor,
];

const ALL_TIME_OF_DAYS = [
    TimeOfDay.Day,
    TimeOfDay.Night,
];

export function timeout(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function preloadImages() {
    const promises: Promise<void>[] = [];
    const imagePaths: string[] = [];

    for (const frameColour of ALL_FRAME_COLOURS) {
        for (const blindPosition of ALL_BLIND_POSITIONS) {
            for (const fabricTone of ALL_FABRIC_TONES) {
                for (const indoorOutdoor of ALL_INDOOR_OUTDOORS) {
                    for (const timeOfDay of ALL_TIME_OF_DAYS) {
                        imagePaths.push(buildImagePath(blindPosition, frameColour, fabricTone, indoorOutdoor, timeOfDay));
                    }
                }
            }
        }
    }

    for (const imagePath of imagePaths) {
        promises.push(new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => resolve();
            img.onerror = () => reject(`Failed to load image. (${imagePath})`);
            img.src = imagePath;
        }));
    }

    await Promise.all(promises);
}

// Shade Open  Out  Day    001
// Shade Open  Out  Night  002
// Shade Open  In   Day    003
// Shade Open  In   Night  004
// Light       Out  Day    005
// Light       Out  Night  006
// Light       In   Day    007
// Light       In   Night  008
// Dark        Out  Day    009
// Dark        Out  Night  010
// Dark        In   Day    011
// Dark        In   Night  012
export function buildImagePath(blindPosition: BlindPosition, frameColour: FrameColour, fabricTone: FabricTone, indoorOutdoor: IndoorOutdoor, timeOfDay: TimeOfDay) {
    const index = (blindPosition * fabricTone) + indoorOutdoor + timeOfDay;
    const paddedIndex = `${index}`.padStart(3, '0');
    return `${VisualiserConfig.assetPath}/ZSV1${frameColour}${paddedIndex}.jpg`;
}
